import { InputAdornment, TextField, InputLabel } from "@mui/material";
import { styled } from "@mui/material/styles";

export const StyledTextField = styled(TextField)(
  ({ 
    theme, 
    error, 
    width, 
    margintop, 
    isIcon, 
    labelCss,
    placeholderFontSize = "14px",
    placeholderFontWeight = "300" 
  }) => ({
    gap: "8px",
    width: width || "100%",
    marginTop: margintop,
    borderRadius: "20px",
    "& .MuiFormHelperText-root": {
      fontStyle: "normal",
      fontWeight: "400",
      fontSize: labelCss ? "20px" : "12px",
      lineHeight: "20px",
      margin: "-8px 0 !important",
    },
    "& .MuiInputBase-root": {
      background: theme.palette.customColor.White,
      paddingRight: isIcon ? "20px !important" : 0,
      padding: "0px",
    },

    "& .MuiInputBase-input": {
      borderRadius: "0px !important",
      padding: "10px 41px 10px 14px !important",
      fontSize: "14px !important",
      lineHeight: "20px !important",
      fontWeight: "400 !important",
      fontFamily: "Lexend, sans-serif !important",
      "&::placeholder": {
        opacity: 0.5,
        fontSize: placeholderFontSize,
        fontWeight: placeholderFontWeight,
        fontFamily: "Lexend, sans-serif !important",
      },
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: error && `1px solid ${theme.palette.customColor.red}!important`,
    },
    ".Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderWidth: "1px !important",
      //   borderColor: `${theme.palette.colors.fieldActiveBorder} !important`,
    },
    // medium screens specific
    [theme.breakpoints.up("md")]: {
      width: "100%",
    },
  })
);

export const StyledInputAdornment = styled(InputAdornment)(() => ({
  position: "absolute",
  right: "10px",
  button: {
    marginRight: "-8px !important",
  },
  ".visible-icon": {
    width: "20px",
    height: "20px",
  },
}));
export const StyledInputLabel = styled(InputLabel)(({ theme, noLabel }) => ({
  display: noLabel ? "none" : "block",
  color: `${theme.palette.primary.main} !important`,
  fontStyle: "normal",
  fontWeight: 400,
  fontSize: "12px",
  lineHeight: "15px",
  margin: "5px 0px",
}));
